import './App.css';
import React from 'react';
import { Route, Routes } from 'react-router-dom';
import useTitle from './hooks/useTitle';
import Home from './Pages/Home';
import About from './Pages/About';
import Layout from './components/Layout';
import Application from './Pages/Application';
import Contact from './Pages/Contact';
import Login from './features/auth/Login';
import Gallery from './Pages/Gallery';
import Applications from './Pages/Applications';
import ApplicationEdit from './Pages/ApplicationEdit';
import PersistLogin from './features/auth/PersistLogin';
import RequireAuth from './features/auth/RequireAuth';

const App = () => {
  useTitle('Agape to the Max');

  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="about" element={<About />} />
        <Route path="application" element={<Application />} />
        <Route path="contact" element={<Contact />} />
        <Route path="gallery" element={<Gallery />} />
        <Route path="login" element={<Login />} />

        {/* Protected Routes */}
        <Route element={<PersistLogin />}>
          <Route element={<RequireAuth />}>
            <Route path="applications" element={<Applications />} />
            <Route path="applications/edit/:id" element={<ApplicationEdit />} />
          </Route>
        </Route>
      </Route>
    </Routes>
  );
};

export default App;
